import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ButtonComponent } from '../../../components/button/button.component';
import { CurrencyPipe } from '../../../pipes/currency.pipe';
import { PaymentItem } from '../../../domain/models/payment-done';

@Component({
  selector: 'app-receipt-item-table',
  imports: [
    CommonModule,
    CurrencyPipe,
    ButtonComponent,
  ],
  templateUrl: './receipt-item-table.component.html',
  styleUrl: './receipt-item-table.component.scss'
})
export class ReceiptItemTableComponent {
  @Input() item: PaymentItem;
}
